import React from 'react'
import { List, useListRepository } from 'elentari'
import analistaCentroCustoRepository from './AnalistaCentroCustoRepository'

export default function AnalistaCentroCustos(props) {
  const listOptions = {
    defaultOrder: 'data',
    fields: {
      id: {
        label: 'Id'
      },
      analista: {
        label: 'Analista',
        format: analista => analista.usuario
      }
    }
  }
  const listHook = useListRepository({
    repository: analistaCentroCustoRepository,
    path: 'analistas',
    forceRemove: true
  })
  listHook.onClickEdit = null
  listHook.onClickNew = props.onClickNew

  delete listHook.undoRemove
  listHook.deleteFItem = listHook.removeItem
  delete listHook.removeItem
  return (
    <List
      {...props}
      {...listHook}
      hideDownloadIcon
      removeItem={null}
      undoRemove={null}
      onClickView={null}
      deleteFItem={listHook.deleteFItem}
      listOptions={listOptions}
    />
  )
}
